export const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return DEVICE_TYPE.iOS;
  }

  if (/android/i.test(userAgent)) {
    return DEVICE_TYPE.Android;
  }

  if (/Windows|Macintosh|Linux|X11/.test(userAgent)) {
    return DEVICE_TYPE.Desktop;
  }

  return DEVICE_TYPE.unknown;
};
export const DEVICE_TYPE = {
  iOS: 'iOS',
  Android: 'Android',
  Desktop: 'Desktop',
  unknown: 'unknown'
}
